import { AdminRouteSection } from '@constants/routes';

export const sectionFromPathname = (pathname: string): AdminRouteSection => {
  return (
    Object.values(AdminRouteSection).find((section) => pathname.match(new RegExp(`^${section}`))) ||
    AdminRouteSection.Unknown
  );
};
